import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ICentro } from "@models/ICentros";
import { IUsuarioIdioma, IUsuarioSQL } from "@models/IUserModel";
import { environment } from "environments/environment";
import { SideBarItemInput } from "@models/ISidebar";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class UserApiService {
    constructor(
        private http: HttpClient,
    ) { }


    editUser(user: IUsuarioSQL) {
        return this.http.put(environment.API_URL + 'usuario/edit', user);
    }

    getUserCenters(username: string) {
        return this.http.get<ICentro[]>(environment.API_URL + 'usuario/distribuidor/centros/all', {
            params: {
                username: username,
            },
        });
    }

    getUserMySql(username: string): Observable<IUsuarioSQL> {
        return this.http.get<IUsuarioSQL>(environment.API_URL + 'usuario/areaprivada', {
            params: {
                username: username,
            },
        });
    }

    getUserMySqlConToken(token: string, username: string): Observable<IUsuarioSQL> {
        return this.http.get<IUsuarioSQL>(environment.API_URL + 'usuario/areaprivada', {
            params: {
                token: token,
                username: username,
            },
        });
    }

    getIdiomaOperadorByUserName(token: string, username: string): Observable<IUsuarioIdioma> {
        return this.http.get<IUsuarioIdioma>(environment.API_URL + 'usuario/areaprivada/idioma', {
            params: {
                token: token,
                username: username,
            },
        });
    }

    getUserByIdMySql(idOperador: number, token: string): Observable<IUsuarioSQL> {
        return this.http.get<IUsuarioSQL>(environment.API_URL + 'usuario/areaprivada/id', {
            params: {
                idOperador: idOperador,
                token: token,
            },
        });
    }

    getModulosByPerfil() {
        return this.http.post<SideBarItemInput[]>(environment.API_URL + 'modulos/perfil', {});
    }

    getOperacionesDestacadasPerfil(
        perfil: string,
        notificarTraspaso: boolean,
        citaPrevia: boolean,
        cuadreEntregasNumeroPedido: boolean
    ) {
        return this.http.get<SideBarItemInput[]>(environment.API_URL + 'operacionesDestacadas/modulos/perfil', {
            params: { perfil, notificarTraspaso, citaPrevia, cuadreEntregasNumeroPedido },
        });
    }

}